function Like({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5716_38235)">
    <path d="M9 21H18C18.83 21 19.54 20.5 19.84 19.78L22.86 12.73C22.95 12.5 23 12.26 23 12V10C23 8.9 22.1 8 21 8H14.69L15.64 3.43L15.67 3.11C15.67 2.7 15.5 2.32 15.23 2.05L14.17 1L7.58 7.59C7.22 7.95 7 8.45 7 9V19C7 20.1 7.9 21 9 21ZM9 9L13.34 4.66L12 10H21V12L18 19H9V9ZM1 9H5V21H1V9Z" fill="#5F6F86"/>
    </g>
    <defs>
    <clipPath id="clip0_5716_38235">
    <rect width="24" height="24" fill="black"/>
    </clipPath>
    </defs>
    </svg>
  `;

  return baseXml;
}

export default Like;

// <svg width=${dimensions || "24"} height=${dimensions || "24"} viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
//   <path d="M8.74967 21.75H18.4997C19.3988 21.75 20.168 21.2083 20.493 20.4283L23.7647 12.7908C23.8622 12.5417 23.9163 12.2817 23.9163 12V9.83333C23.9163 8.64166 22.9413 7.66666 21.7497 7.66666H14.9138L15.943 2.71583L15.9755 2.36916C15.9755 1.92499 15.7913 1.51333 15.4988 1.22083L14.3505 0.0833282L7.21134 7.22249C6.82134 7.61249 6.58301 8.15416 6.58301 8.74999V19.5833C6.58301 20.775 7.55801 21.75 8.74967 21.75ZM8.74967 8.74999L13.4513 4.04833L11.9997 9.83333H21.7497V12L18.4997 19.5833H8.74967V8.74999ZM0.0830078 8.74999H4.41634V21.75H0.0830078V8.74999Z" fill=${`"${col}"`}/>
// </svg>
